module.exports = __webpack_public_path__ + "img/gsg.7697f295.png";